"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isColor = exports.rgb2Hex = exports.hexToRGBA = exports.hex2RGB = exports.getContrast = exports.generatePalette = void 0;

var componentToHex = function componentToHex(c) {
  var hex = c.toString(16);
  return hex.length === 1 ? "0".concat(hex) : hex;
};

var rgb2Hex = function rgb2Hex(r, g, b) {
  return "#".concat(componentToHex(r)).concat(componentToHex(g)).concat(componentToHex(b));
};

exports.rgb2Hex = rgb2Hex;

var hexToRGBA = function hexToRGBA(hex) {
  var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.5;
  var c;

  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split("");

    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }

    c = "0x".concat(c.join(""));
    return "rgba(".concat(c >> 16 & 255, ",").concat(c >> 8 & 255, ",").concat(c & 255, ",").concat(alpha, ")");
  } else {
    // console.error("Bad Hex:", hex, "Alpha: ", alpha);
    return false;
  }
};

exports.hexToRGBA = hexToRGBA;

var isColor = function isColor(color) {
  if (hex2RGB(color)) return true;else return false;
};

exports.isColor = isColor;

var hex2RGB = function hex2RGB(hex) {
  var c;

  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split("");

    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }

    c = "0x".concat(c.join("")); // eslint-disable-next-line no-bitwise

    return {
      r: c >> 16 & 255,
      g: c >> 8 & 255,
      b: c & 255
    };
  } else {
    return false; // throw new Error("Bad Hex");
  }
}; // https://24ways.org/2010/calculating-color-contrast
// https://www.w3.org/WAI/ER/WD-AERT/#color-contrast


exports.hex2RGB = hex2RGB;

var getContrast = function getContrast(hexColor) {
  var rgb = hex2RGB(hexColor);

  if (rgb) {
    var yiq = (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    return yiq >= 128 ? "#000000" : "#FFFFFF";
  } else return false;
};

exports.getContrast = getContrast;

var variacion = function variacion(H, Z, value) {
  return H / Z * value;
}; // https://www.w3.org/TR/WCAG20/#relativeluminancedef


var colorBrightness = function colorBrightness(color, value) {
  var rgb = hex2RGB(color);
  var t = {};

  if (rgb) {
    if (value < 0) {
      t.r = rgb.r - parseInt(rgb.r / 100 * -value, 10);
      t.g = rgb.g - parseInt(rgb.g / 100 * -value, 10);
      t.b = rgb.b - parseInt(rgb.b / 100 * -value, 10);
    } else {
      t.r = parseInt(variacion(255 - rgb.r, 100, value), 10) + rgb.r;
      t.g = parseInt(variacion(255 - rgb.g, 100, value), 10) + rgb.g;
      t.b = parseInt(variacion(255 - rgb.b, 100, value), 10) + rgb.b;
    }

    return rgb2Hex(t.r, t.g, t.b);
  } else return false;
};
/**
 * Function to generate a colors palette.
 * This function return a array of colors
 * in the following format: [{color: 'string', textColor: 'string', name: 'string' }]
 * @param {string} hexColor Color in hexadecimal format
 * @param {string} name Name of color
 * @param {integer} cantShape Cant of variations
 */


var generatePalette = function generatePalette(hexColor, name) {
  var cantShape = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 22;
  var step = 100 / Math.ceil(cantShape / 2);
  var startVal = step * Math.floor(cantShape / 2);
  var colors = [];

  if (isColor(hexColor)) {
    for (var i = 0; i < cantShape; i += 1) {
      var color = colorBrightness(hexColor, startVal - i * step);
      var textColor = getContrast(color);
      var tmpName = void 0;
      if (i > cantShape / 2) tmpName = "".concat(name, "-").concat(i);else if (i === cantShape / 2) tmpName = name;else tmpName = "".concat(name, "-").concat(i + 1);
      colors.push({
        name: tmpName,
        color: color,
        textColor: textColor
      });
    }
  }

  return colors;
};

exports.generatePalette = generatePalette;